<template>
  <section v-if="views.length" class="your-views" aria-labelledby="your-views-title">
    <h2 id="your-views-title">Your <AiViewTerm plural /></h2>
    <ol><li v-for="view in views" :key="view.id"><router-link :to="`/view/${view.id}`"><img v-if="view.illustration?.src" :src="view.illustration.src" alt="" loading="lazy"/><span class="your-views-copy"><strong><ViewReadingTitle :text="view.title" /></strong><small>{{view.visibility==='public'?'Shared':'Not shared'}}</small></span><span class="your-views-arrow" aria-hidden="true"><ArrowUpRightIcon data-exhibition-icon /></span></router-link></li></ol>
  </section>
</template>
<script>
import AiViewTerm from '../ui/AiViewTerm.vue';
import ViewReadingTitle from './ViewReadingTitle.vue';
import { ownMuseumViews } from '../../utils/viewMuseumSession';
export default {
  components:{AiViewTerm,ViewReadingTitle},data:()=>({views:ownMuseumViews()}),
  mounted(){window.addEventListener('museum-views-updated',this.refresh);},
  activated(){this.refresh();},
  beforeUnmount(){window.removeEventListener('museum-views-updated',this.refresh);},
  methods:{refresh(){this.views=ownMuseumViews();}},
};
</script>
<style scoped>
.your-views{margin:2.8rem 0 3.5rem;padding-top:1.5rem;border-top:1px solid var(--site-border,#ddd)}
.your-views h2{font:27px 'EB Garamond',serif;margin:0 0 1.2rem}
.your-views ol{list-style:none;padding:0;margin:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px 32px}
.your-views a{display:flex;align-items:center;gap:16px;padding:16px 0;color:var(--site-text-primary);text-decoration:none;border-bottom:1px solid color-mix(in srgb,currentColor 12%,transparent)}
.your-views img{flex-shrink:0;width:82px;height:50px;object-fit:cover}
.your-views-copy{min-width:0}
.your-views strong{display:block;font:20px/1.3 'EB Garamond',serif}
.your-views small{display:block;margin-top:6px;font:12px 'Quattrocento Sans',sans-serif;color:var(--site-text-secondary)}
.your-views-arrow{margin-left:auto;opacity:.45;transition:opacity 160ms ease,transform 160ms ease}
.your-views a:hover .your-views-arrow{opacity:1;transform:translate(2px,-2px)}
@media(max-width:767px){.your-views ol{grid-template-columns:1fr}.your-views strong{font-size:19px}}
@media(prefers-reduced-motion:reduce){.your-views-arrow{transition:none}}
</style>
